import { Pipe, PipeTransform } from '@angular/core';
import { PontoFisico } from '../../modelos/ponto-fisico';

@Pipe({
  name: 'filtroPontoFisico'
})
export class FiltroPontoFisicoPipe implements PipeTransform {

  transform(pontosFisicos: PontoFisico[], filtro?: string): any {
    if (pontosFisicos === undefined || filtro === undefined || filtro.trim() === '') {
      return pontosFisicos;
    }
    filtro = filtro.toLocaleLowerCase();
    return pontosFisicos.filter(pontoFisico => pontoFisico.nomePontoFisico.toLocaleLowerCase().indexOf(filtro) >= 0);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/filtros/pipes/filtro-ponto-fisico.pipe.ts